import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const BlogPage = () => {
  useEffect(() => {
    // Update page title and meta description
    document.title = 'Blog | Web Tasarım İpuçları ve Dijital Pazarlama Rehberi';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Webcoll blog sayfasında web tasarım trendleri, SEO ipuçları, dijital pazarlama stratejileri ve e-ticaret rehberlerini keşfedin.');
    }

    // Add structured data
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "Blog",
      "name": "Webcoll Blog",
      "description": "Web tasarım, SEO ve dijital pazarlama hakkında güncel içerikler",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/blog`,
      "publisher": {
        "@type": "Organization",
        "name": "Webcoll",
        "logo": {
          "@type": "ImageObject",
          "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/logo.png`
        }
      },
      "blogPost": [
        {
          "@type": "BlogPosting",
          "headline": "2024 Web Tasarım Trendleri",
          "description": "Bu yıl öne çıkan web tasarım trendlerini keşfedin",
          "author": {
            "@type": "Organization",
            "name": "Webcoll"
          },
          "datePublished": "2024-12-19"
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const blogPosts = [
    {
      id: 1,
      title: '2024 Web Tasarım Trendleri',
      excerpt: 'Bu yıl öne çıkan web tasarım trendlerini ve nasıl uygulanacağını keşfedin.',
      image: 'https://public.readdy.ai/ai/img_res/4c663eacfaa78ac88a9d1a0d645ce534.jpg',
      date: '19 Aralık 2024',
      category: 'Web Tasarım',
      readTime: '5 dk',
      slug: '2024-web-tasarim-trendleri'
    },
    {
      id: 2,
      title: 'SEO İpuçları: Google\'da Üst Sıralara Çıkın',
      excerpt: 'Web sitenizin arama motorlarında daha iyi sıralanması için pratik SEO teknikleri.',
      image: 'https://readdy.ai/api/search-image?query=SEO%20optimization%20concept%2C%20search%20engine%20ranking%2C%20Google%20analytics%20dashboard%2C%20keyword%20research%20tools%2C%20digital%20marketing%20strategy%2C%20website%20traffic%20growth%20visualization&width=400&height=250&seq=blog2&orientation=landscape',
      date: '18 Aralık 2024',
      category: 'SEO',
      readTime: '7 dk',
      slug: 'seo-ipuclari-googleda-ust-siralara-cikin'
    },
    {
      id: 3,
      title: 'E-ticaret Sitesi Açmanın Püf Noktaları',
      excerpt: 'Başarılı bir online mağaza kurmak için bilmeniz gereken her şey.',
      image: 'https://readdy.ai/api/search-image?query=E-commerce%20website%20design%2C%20online%20shopping%20interface%2C%20product%20catalog%20layout%2C%20shopping%20cart%20design%2C%20payment%20gateway%20integration%2C%20mobile%20commerce%20experience&width=400&height=250&seq=blog3&orientation=landscape',
      date: '17 Aralık 2024',
      category: 'E-ticaret',
      readTime: '6 dk',
      slug: 'e-ticaret-sitesi-acmanin-puf-noktalari'
    },
    {
      id: 4,
      title: 'Mobil Uyumlu Tasarımın Önemi',
      excerpt: 'Neden her web sitesi mobil cihazlar için optimize edilmeli?',
      image: 'https://readdy.ai/api/search-image?query=Mobile%20responsive%20web%20design%2C%20smartphone%20tablet%20interface%2C%20adaptive%20layout%20design%2C%20mobile%20user%20experience%2C%20cross-device%20compatibility%2C%20responsive%20grid%20system&width=400&height=250&seq=blog4&orientation=landscape',
      date: '16 Aralık 2024',
      category: 'Mobil Tasarım',
      readTime: '4 dk',
      slug: 'mobil-uyumlu-tasarimin-onemi'
    },
    {
      id: 5,
      title: 'Sosyal Medya Entegrasyonu Rehberi',
      excerpt: 'Web sitenizi sosyal medya platformlarıyla nasıl entegre edersiniz?',
      image: 'https://readdy.ai/api/search-image?query=Social%20media%20integration%2C%20website%20social%20sharing%20buttons%2C%20Instagram%20Facebook%20Twitter%20integration%2C%20social%20media%20marketing%20strategy%2C%20digital%20presence%20optimization&width=400&height=250&seq=blog5&orientation=landscape',
      date: '15 Aralık 2024',
      category: 'Sosyal Medya',
      readTime: '5 dk',
      slug: 'sosyal-medya-entegrasyonu-rehberi'
    },
    {
      id: 6,
      title: 'Web Sitesi Hızlandırma Teknikleri',
      excerpt: 'Sitenizin yükleme hızını artırmak için uygulayabileceğiniz yöntemler.',
      image: 'https://readdy.ai/api/search-image?query=Website%20speed%20optimization%2C%20fast%20loading%20web%20pages%2C%20performance%20metrics%20dashboard%2C%20page%20speed%20insights%2C%20web%20performance%20tools%2C%20loading%20time%20optimization&width=400&height=250&seq=blog6&orientation=landscape',
      date: '14 Aralık 2024',
      category: 'Performans',
      readTime: '8 dk',
      slug: 'web-sitesi-hizlandirma-teknikleri'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-600 to-purple-700"></div>
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-10 left-10 w-40 h-40 bg-white rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-10 right-10 w-32 h-32 bg-purple-300 rounded-full blur-3xl animate-pulse delay-1000"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Dijital dünyada{' '}
            <span className="text-yellow-300">
              öne çıkın
            </span>
          </h1>
          <p className="text-xl md:text-2xl text-blue-100 max-w-3xl mx-auto leading-relaxed">
            Web tasarım trendleri, SEO ipuçları ve dijital pazarlama stratejileri ile markanızı büyütün.
          </p>
        </div>
      </section>

      {/* Blog Posts Section */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              En Son <span className="text-blue-600">İçerikler</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Web tasarım, SEO ve dijital pazarlama dünyasından güncel haberler ve rehberler.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogPosts.map((post) => (
              <article 
                key={post.id}
                className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 overflow-hidden group"
              >
                <div className="relative overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-48 object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="bg-blue-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                      {post.category}
                    </span>
                  </div>
                </div>
                
                <div className="p-6">
                  <div className="flex items-center text-sm text-gray-500 mb-3">
                    <i className="ri-calendar-line mr-2"></i>
                    <span>{post.date}</span>
                    <span className="mx-2">•</span>
                    <i className="ri-time-line mr-1"></i>
                    <span>{post.readTime}</span>
                  </div>
                  
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors duration-300">
                    {post.title}
                  </h3>
                  
                  <p className="text-gray-600 mb-4 leading-relaxed">
                    {post.excerpt}
                  </p>
                  
                  <Link 
                    to={`/blog/${post.slug}`}
                    className="inline-flex items-center text-blue-600 font-semibold hover:text-purple-600 transition-colors duration-300"
                  >
                    Devamını Oku
                    <i className="ri-arrow-right-line ml-2"></i>
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="py-20 bg-gradient-to-br from-blue-600 to-purple-700 relative overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-10 left-10 w-40 h-40 bg-white rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-10 right-10 w-32 h-32 bg-purple-300 rounded-full blur-3xl animate-pulse delay-1000"></div>
        </div>
        
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-8">
            Güncel kalın, <span className="text-yellow-300">fırsatları kaçırmayın</span>
          </h2>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto mb-12">
            Web tasarım trendleri, SEO ipuçları ve özel kampanyalarımızdan haberdar olmak için bültenimize abone olun.
          </p>
          
          <div className="max-w-md mx-auto">
            <div className="flex flex-col sm:flex-row gap-4">
              <input
                type="email"
                placeholder="E-posta adresiniz"
                className="flex-1 px-6 py-4 rounded-xl border-0 focus:ring-4 focus:ring-white/20 text-gray-900 placeholder-gray-500"
              />
              <button className="px-8 py-4 bg-white text-blue-600 font-bold rounded-xl hover:bg-gray-100 transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap">
                Abone Ol
                <i className="ri-mail-send-line ml-2"></i>
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* WhatsApp Floating Button */}
      <div className="fixed bottom-6 right-6 z-50">
        <a
          href="https://wa.me/905451485952"
          target="_blank"
          rel="noopener noreferrer"
          className="w-16 h-16 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center shadow-2xl transition-all duration-300 transform hover:scale-110 animate-pulse"
        >
          <i className="ri-whatsapp-line text-white text-2xl"></i>
        </a>
      </div>

      <Footer />
    </div>
  );
};

export default BlogPage;